module.exports = __webpack_public_path__ + "media/sam.1c2bb3db.mp4";